type SwitchClient = {
    clientId: number | string;
    clientName: string;
    clientLogoUrl: string;
    isClient: boolean;
};

type BuildUrlOptions = {
    targetPath?: string;
    extraParams?: Record<string, string | number | boolean | null | undefined>;
};

type UseClientSwitcherParams = {
    userLoginUrl?: string | null;
};

export function useClientSwitcher({ userLoginUrl }: UseClientSwitcherParams) {
    const buildSwitchUrl = (
        client: SwitchClient,
        options?: BuildUrlOptions
    ) => {
        const basePath =
            options?.targetPath ??
            window.location.pathname.replace(/^\/(client|subclient)/, '');

        const pathPrefix = client.isClient ? 'client' : 'subclient';

        const params = new URLSearchParams({
            clientId: String(client.clientId),
            isClient: String(client.isClient),
            clientName: client.clientName,
            clientLogoUrl: client.clientLogoUrl,
            loginUrl: userLoginUrl ?? ''
        });

        // ✅ append extra params safely
        Object.entries(options?.extraParams ?? {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                params.set(key, String(value));
            }
        });

        return `/${pathPrefix}${basePath}?${params.toString()}`;
    };

    const switchClient = (
        client?: SwitchClient,
        options?: BuildUrlOptions
    ) => {
        if (!client) return;

        sessionStorage.removeItem('currentSelectedClient');
        const url = buildSwitchUrl(client, options);
        window.location.replace(url);
    };

    return {
        buildSwitchUrl,
        switchClient
    };
}

